import React, { useState } from "react";
import Context from "../context";
import copy from "copy-to-clipboard";

export default function FloatingSettings({ setHowto }: { setHowto: (v: any) => void }) {
  const { userInfo, toggleMsgTab, msgTab } = React.useContext(Context);
  const [open, setOpen] = useState(false);

  const menu: React.CSSProperties = {
    position: "fixed", bottom: "70px", left: "16px",
    background: "linear-gradient(160deg,#1e1e38,#151525)",
    border: "1px solid #252545", borderRadius: "12px",
    padding: "8px", width: "200px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.6)", zIndex: 8001
  };
  const item: React.CSSProperties = {
    display: "flex", alignItems: "center", gap: "10px",
    padding: "10px 12px", borderRadius: "8px", cursor: "pointer",
    fontSize: "13px", color: "#aaa", border: "none",
    background: "transparent", width: "100%", textAlign: "left"
  };

  const items = [
    { icon: "🛡️", label: "Provably Fair", action: () => { setHowto("more"); setOpen(false); } },
    { icon: "📋", label: "Game Rules", action: () => { setHowto("more"); setOpen(false); } },
    { icon: "💰", label: "Game Limits", action: () => setOpen(false) },
    { icon: "🎁", label: "Referral Program", action: () => setOpen(false) },
    { icon: "🎰", label: "Daily Bonus", action: () => setOpen(false) },
    { icon: "💬", label: msgTab ? "Hide Chat" : "Show Chat", action: () => { toggleMsgTab(); setOpen(false); } },
  ];

  return (
    <>
      {open && (
        <div style={{ position: "fixed", inset: 0, zIndex: 8000 }} onClick={() => setOpen(false)} />
      )}
      {open && (
        <div style={menu}>
          <div style={{ color: "#555", fontSize: "10px", textTransform: "uppercase", letterSpacing: "1px", padding: "4px 12px 8px", borderBottom: "1px solid #252545", marginBottom: "6px" }}>
            Settings
          </div>
          {items.map((it, i) => (
            <button key={i} style={item}
              onMouseEnter={e => (e.currentTarget.style.background = "rgba(255,69,0,0.08)")}
              onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
              onClick={it.action}>
              <span style={{ fontSize: "16px" }}>{it.icon}</span>
              <span>{it.label}</span>
            </button>
          ))}
        </div>
      )}
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          position: "fixed", bottom: "20px", left: "16px", zIndex: 8001,
          width: "44px", height: "44px", borderRadius: "12px",
          background: open ? "linear-gradient(135deg,#ff4500,#ff6a00)" : "linear-gradient(160deg,#1e1e38,#151525)",
          border: "1px solid " + (open ? "#ff4500" : "#252545"),
          color: open ? "#fff" : "#aaa",
          cursor: "pointer", fontSize: "20px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all 0.2s"
        }}>
        ⚙️
      </button>
    </>
  );
}
